import React, { useState } from 'react';
import { periodContaining, shiftPeriod, periodLabel } from '../lib/payPeriods';

// ‹ Prev · period · Next › for the Accounting pages, plus a custom date-range
// fallback. `cfg` is { type, anchorDate } from the store's accounting profile
// (mode 'month' pins type to monthly). `value` is { start, end }; a value
// that doesn't line up with a period is shown as a custom range.
export default function PeriodPicker({ cfg, value, onChange, maxDate, tour }) {
  const period = periodContaining(value.start, cfg);
  const aligned = period.start === value.start && period.end === value.end;
  const [custom, setCustom] = useState(!aligned);

  const go = (dir) => {
    const p = shiftPeriod(period, dir);
    onChange({ start: p.start, end: p.end });
    setCustom(false);
  };
  const next = shiftPeriod(period, 1);
  const nextDisabled = !!maxDate && next.start > maxDate;

  return (
    <div className="period-picker" data-tour={tour}>
      <div className="chip-row">
        <button className="chip" onClick={() => go(-1)} title="Previous period">‹</button>
        <button className={`chip ${!custom ? 'active' : ''}`} onClick={() => { onChange({ start: period.start, end: period.end }); setCustom(false); }}>
          {custom ? 'Custom range' : periodLabel(period)}
        </button>
        <button className="chip" onClick={() => go(1)} disabled={nextDisabled} title="Next period">›</button>
        <button className={`chip ${custom ? 'active' : ''}`} onClick={() => setCustom(c => !c)}>Custom…</button>
      </div>
      {custom && (
        <div className="chip-row" style={{ marginTop: 6 }}>
          <input className="field" type="date" value={value.start} max={value.end}
            onChange={e => e.target.value && onChange({ start: e.target.value, end: value.end })} />
          <span className="hint">to</span>
          <input className="field" type="date" value={value.end} min={value.start} max={maxDate || undefined}
            onChange={e => e.target.value && onChange({ start: value.start, end: e.target.value })} />
        </div>
      )}
    </div>
  );
}
